module.exports = __webpack_public_path__ + "assets/fonts/EBGaramond-MediumItalic.d27d5d5c.ttf";